import { z } from 'zod';
import { paginationQuerySchema, patchSchemaOf, slugSchema } from './common';
/**
 * Categories and tags share a shape but not a role:
 *  - a post has at most one category (its primary subject), which drives the
 *    blog's top-level filter chips;
 *  - a post has many tags, used for cross-linking related reading.
 *
 * Keeping them as separate tables rather than one polymorphic "terms" table
 * costs one extra migration and buys readable queries and real foreign keys.
 */
const termBaseSchema = z.object({
    name: z.string().trim().min(1).max(80),
    slug: slugSchema.optional(),
    description: z.string().trim().max(300).nullish(),
});
export const createCategorySchema = termBaseSchema.extend({
    /** Accent colour for the filter chip. Hex, validated so CSS can't be injected. */
    color: z
        .string()
        .regex(/^#[0-9a-fA-F]{6}$/, 'Use a 6-digit hex colour such as #7c3aed.')
        .nullish(),
    sortOrder: z.number().int().min(0).default(0),
});
// `patchSchemaOf`, not `.partial()`: `sortOrder` carries a default, so a rename used to
// reset the category's position in the filter row. See the note on `patchSchemaOf`.
export const updateCategorySchema = patchSchemaOf(createCategorySchema.shape);
export const createTagSchema = termBaseSchema;
// No defaults in `termBaseSchema` today, so this is equivalent to `.partial()` — spelled
// the same way as its neighbour so that adding one later cannot quietly break it.
export const updateTagSchema = patchSchemaOf(termBaseSchema.shape);
export const taxonomyQuerySchema = paginationQuerySchema.extend({
    q: z.string().trim().max(120).optional(),
});
//# sourceMappingURL=taxonomy.js.map